import { WheelField, WheelValue } from "../../../../util/enums";
import { wheelFields } from "../WheelOfFortune.constants";

const getFieldsWithValue = (value: WheelValue): WheelField[] => {
    return wheelFields.filter(field => field.value === value);
};

export default getFieldsWithValue;